import { useEffect, useState } from "react";

import { Field, Form, Formik } from "formik";
import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Checkbox, CheckboxGroup, Divider, Flex, FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { HttpStatusCode } from "axios";

import ArrowIcon from "@/assets/ArrowIcon";
import { addVesselShipOwnerNominationSchema } from "@/schemas/addVesselShipOwnerNominationSchema";
import { getShipOwnerData } from "@/services/shipOwnerService";

import FileUploader from "../Fields/FileUploader";
import SelectShip from "../Selects/SelectShip";
import { COLORS } from "@/common/constants";

const ModalAddNewVessel = ({ isOpen, onClose, handleConfirmToCancel, handleSubmitVessel, isSubmitting }: any) => {
    const [listCompanyName, setListCompanyName] = useState([]) as any;

    const getListCompanyShipName = async () => {
        const response = await getShipOwnerData() as any;
        if (response.status === HttpStatusCode.Ok) {
            const formattedData = response.data.map((item: any) => ({
                value: item.shipOwnerId,
                label: item.onBehalfCompany,
            }));
            setListCompanyName(formattedData);
        }
    }

    useEffect(() => {
        getListCompanyShipName();
    }, [])

    return (
        <Modal onClose={onClose} isOpen={isOpen}>
            <ModalOverlay />
            <ModalContent borderRadius={15} maxWidth="1000px">
                <ModalHeader textAlign='center'>Add Vessel</ModalHeader>
                <ModalBody marginTop={-5}>
                    <div className="form-container">
                        <Formik
                            initialValues={{
                                imoRegNumber: '',
                                vesselName: '',
                                smc: null,
                                onBehalfCompany: '',
                                type: []
                            }}
                            validationSchema={addVesselShipOwnerNominationSchema}
                            onSubmit={(values) => {
                                handleSubmitVessel(values);
                            }}
                            enableReinitialize={true}
                        >
                            {(props) => (
                                <Form>
                                    <Field name='type'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.type && form.touched.type} marginBottom={4}>
                                                <div className="form-field-container">
                                                    <FormLabel htmlFor="type" className="form-label">Type<span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <div className="form-input-container">
                                                        <CheckboxGroup
                                                            value={props.values.type}
                                                            onChange={(value: string[]) => props.setFieldValue('type', value)}
                                                        >
                                                            <Flex gap={8}>
                                                                <Checkbox value="SIRE | BIRE">SIRE | BIRE</Checkbox>
                                                                <Checkbox value="Vetting">Vetting</Checkbox>
                                                            </Flex>
                                                        </CheckboxGroup>
                                                        <FormErrorMessage>{form.errors.type}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='imoRegNumber'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.imoRegNumber && form.touched.imoRegNumber} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">IMO / Registrasi Number<span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <div className="form-input-container">
                                                        <Input {...field} placeholder='IMO / Registrasi Number' className="form-input" />
                                                        <FormErrorMessage>{form.errors.imoRegNumber}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='vesselName'>
                                        {({ field, form }: any) => (
                                            <FormControl isInvalid={form.errors.vesselName && form.touched.vesselName} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">Vessel Name<span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <div className="form-input-container">
                                                        <Input {...field} placeholder='Vessel Name' className="form-input" />
                                                        <FormErrorMessage>{form.errors.vesselName}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='smc'>
                                        {({ form }: any) => (
                                            <FormControl style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">SMC</FormLabel>
                                                    <div className="form-input-container">
                                                        <FileUploader onDrop={(e) => props.setFieldValue('smc', e[0])} isInvalid={form.errors.smc && form.submitCount} isDisabled={props.isSubmitting} type="registration-inspectingcompany" />
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name='onBehalfCompany'>
                                        {({ form }: any) => (
                                            <FormControl isInvalid={form.errors.onBehalfCompany && form.touched.onBehalfCompany} style={{ marginBottom: 15 }}>
                                                <div className="form-field-container">
                                                    <FormLabel className="form-label">On Behalf Company<span style={{ color: 'red' }}>*</span></FormLabel>
                                                    <div className="form-input-container">
                                                        <SelectShip placeholder="Choose Company" name='onBehalfCompany' handleChange={({ value }: any) => props.setFieldValue('onBehalfCompany', value)} value={props.values.onBehalfCompany} options={listCompanyName} hasError={form.errors.onBehalfCompany && form.touched.onBehalfCompany} isDisabled={isSubmitting} />
                                                        <FormErrorMessage>{form.errors.onBehalfCompany}</FormErrorMessage>
                                                    </div>
                                                </div>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Divider />
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button
                                            mt={4}
                                            bgColor='white'
                                            borderColor='#D0D5DD'
                                            isLoading={isSubmitting}
                                            marginRight={5}
                                            onClick={handleConfirmToCancel}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            mt={4}
                                            bgColor={COLORS.BUTTON.BACKGROUND}
                                            color={COLORS.BUTTON.FOREGROUND}
                                            isLoading={isSubmitting}
                                            type='submit'
                                            rightIcon={<ArrowIcon />}
                                        >
                                            Add Vessel
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default ModalAddNewVessel;